import DeclarationApprovalStep from './DeclarationApprovalStep.vue'
import { declarationApprovalDescriptor } from './descriptor'
import { createDeclarationApprovalController } from './declaration-approval-controller'

const declarationApprovalStepImplementation = Object.freeze({
    descriptor: declarationApprovalDescriptor,
    component: DeclarationApprovalStep,
    createController: createDeclarationApprovalController,
})

export {
    DeclarationApprovalStep,
    createDeclarationApprovalController,
    declarationApprovalDescriptor,
    declarationApprovalStepImplementation,
}
